// extracted by mini-css-extract-plugin
export var contrastLow = "_2s-1";
export var externalLink = "_2s-2";
export var externalLinkIcon = "_2s-3";
export var link = "_2s-0";
export var linkLabel = "_2s-4";